function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H32V32H0z",
  transform: "translate(-418 -80) translate(0 64) translate(418 16)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.755.019c-1.998-.144-3.971.515-5.483 1.83C1.762 3.162.836 5.025.702 7.024c-.008.124.036.246.121.337.086.091.204.143.329.143.26-.001.474-.204.491-.463.26-3.502 3.22-6.185 6.731-6.1 3.51.086 6.337 2.91 6.426 6.421.088 3.51-2.592 6.473-6.094 6.736-.267.018-.474.239-.476.506 0 .121.05.237.139.32.088.083.206.126.327.119 3.955-.25 7.04-3.523 7.055-7.485.015-3.963-3.043-7.26-6.996-7.54z",
  transform: "translate(-418 -80) translate(0 64) translate(418 16) translate(8 8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.622 2.381C6.624.708 2.788 3.473 2.577 7.206c-.006.077.02.153.073.21.053.056.126.089.204.089H3.2c.167-.001.305-.13.32-.296.213-3.162 3.546-5.458 6.946-3.86.845.4 1.527 1.078 1.93 1.922 1.633 3.465-.782 6.857-4.029 6.964-.076.003-.136.065-.137.141v.462c-.012.087.015.175.074.24.06.066.144.101.232.098 3.743-.21 6.512-4.064 4.814-8.071-.52-1.23-1.498-2.207-2.728-2.724z",
  transform: "translate(-418 -80) translate(0 64) translate(418 16) translate(8 8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.388 7.516L2.801 8.66c-.262.07-.467.272-.54.533-.072.26-.002.54.186.736l1.058 1.042-3.22 3.268c-.248.252-.343.617-.248.957.094.34.363.604.705.693.342.088.705-.013.952-.264l3.22-3.281 1.059 1.044c.195.198.483.271.749.193.266-.079.467-.298.523-.57l1.06-4.592c.06-.256-.017-.525-.204-.71-.188-.184-.458-.258-.713-.194v.002z",
  transform: "translate(-418 -80) translate(0 64) translate(418 16) translate(8 8)"
}))))));

var SvgBlackAction = function SvgBlackAction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlackAction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/black_action.3a9fc568.svg";
export { ForwardRef as ReactComponent };